import React from "react";

interface AnnotationBadgeProps {
    number: string | number;
}

const CSS_CLASS_NAME = "c-annotation-badge";
const AnnotationBadge = ({ number }: AnnotationBadgeProps) => {
    return <span className={CSS_CLASS_NAME}>{number}</span>;
};

export default AnnotationBadge;
